import {
  addNavMenuItem,
  PageLocationId,
  registerPageTab,
} from "@bb-vendure/admin-ui/core";
import EmailTemplatesComponent from "./Email-templates/templates.component";
import EmailHistoryListComponent from "./email-history/list.component";

export default [
  // addNavMenuItem(
  //   {
  //     id: "email-templates",
  //     label: "Email Templates",
  //     routerLink: ["/extensions/email-templates"],
  //     icon: "envelope",
  //   },
  //   "notifications"
  // ),

  addNavMenuItem(
    {
      id: "email-history",
      label: "nav.email-history",
      routerLink: ["/extensions/email-history"],
      icon: "envelope",
    },
    "notifications"
  ),

  registerPageTab({
    location: "notification-history" as PageLocationId,
    tab: "nav.email-history",
    route: "/extensions/email-history",
    tabIcon: "envelope",
    component: EmailHistoryListComponent,
  }),
  registerPageTab({
    location: "notification-template-list" as PageLocationId,
    tab: "nav.email-templates",
    route: "/extensions/email-templates",
    tabIcon: "envelope",
    component: EmailTemplatesComponent,
  }),
];
